import { Link } from "react-router-dom";

import { ROUTES } from "~/router";
import { useUserStore } from "~/stores";
import { customIcons } from "~/ui";
import { tw } from "~/utils";

interface LogoProps {
  className?: string;
  handleOnClick?: () => void;
}

export const Logo = ({ className, handleOnClick }: LogoProps) => {
  const isLogged = !!useUserStore((state) => state.role);

  return (
    <Link
      to={isLogged ? ROUTES.hubHome : ROUTES.fullLogin}
      className="flex shrink-0"
      onClick={() => {
        handleOnClick?.();
      }}
    >
      <customIcons.LogoIcon className={tw("h-10", className)} />
    </Link>
  );
};
